import ShipmentList from "./list";


if (document.body.getAttribute("data-current-path") === "shipments") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new ShipmentList();
    }
}